// ##############################
// // // PricingPage Pages View styles
// #############################

import {
  container,
  defaultFont,
  cardTitle,
  roseColor
} from "assets/jss/material-dashboard-pro-react.jsx";

const pricingPageStyle = () => ({
  container: {
    ...container,
    zIndex: "4"
  },
  title: {
    ...defaultFont,
    color: "#FFFFFF",
    marginTop: "5vh",
    margin: "0",
    textAlign: "center"
  },
  description: {
    fontSize: "18px",
    color: "#FFFFFF",
    textAlign: "center",
    marginTop: "0",
    marginBottom: "36px"
  },
  cardTitleWhite: {
    ...cardTitle,
    color: "#FFFFFF !important"
  },
  cardCategory: {
    color: "#999999",
    marginTop: "10px"
  },
  cardCategoryWhite: {
    color: "#FFFFFF",
    marginTop: "10px"
  },
  icon: {
    color: "rgba(255, 255, 255, 0.76)",
    margin: "10px auto 0",
    width: "130px",
    height: "130px",
    border: "1px solid #E5E5E5",
    borderRadius: "50%",
    lineHeight: "174px",
    "& svg": {
      width: "55px",
      height: "55px"
    },
    "& .fab,& .fas,& .far,& .fal,& .material-icons": {
      width: "55px",
      fontSize: "55px"
    }
  },
  iconWhite: {
    color: "#FFFFFF"
  },
  iconRose: {
    color: roseColor
  },
  marginTop30: {
    marginTop: "30px"
  },
  zAdjust: {
    zIndex: 10
  },
  scrollContainer: {
    position: "relative",
    zIndex: 10,
    paddingTop: "15vh",
    paddingBottom: "5vh"
  }
});

export default pricingPageStyle;
